import { backendUrls, type AppConfiguration, type AppFrameApi } from '@puffin/app-frame-api';
import { updateBrowserTitleStatus } from '../state/notifications/browser-title';
import { showNotification } from '../state/notifications/notifications';
import { showTaskCompletedAnimation } from '../state/notifications/task-completed-animation';
import { askForBrowserNotificationPermission } from '../state/notifications/browser-notification-permission';
import { initializeGraphQLClient, type GraphQLClientDependencies } from './graphql-client';

type AppFrameApiDependencies = GraphQLClientDependencies &
  Pick<AppFrameApi, 'getUser' | 'trackAnalytics'> & {
    getAppConfiguration: () => AppConfiguration;
  };

export const initAppFrameApi = (dependencies: AppFrameApiDependencies) => {
  const testTurtleClient = initializeGraphQLClient(`${backendUrls.testTurtle}/graphql`, dependencies);
  const deployDuckClient = initializeGraphQLClient(`${backendUrls.deployDuck}/graphql`, dependencies);
  const platformPlatypusClient = initializeGraphQLClient(`${backendUrls.platformPlatypus}/graphql`, dependencies);

  (window as Window & { appFrameApi?: AppFrameApi }).appFrameApi = {
    showNotification,
    showTaskCompletedAnimation,
    askForBrowserNotificationPermission,
    updateBrowserTitleStatus,
    getTestTurtleClient: () => testTurtleClient,
    getDeployDuckClient: () => deployDuckClient,
    getPlatformPlatypusClient: () => platformPlatypusClient,
    getAccessToken: dependencies.getAccessToken,
    getUser: dependencies.getUser,
    getAppConfiguration: dependencies.getAppConfiguration,
    trackAnalytics: dependencies.trackAnalytics,
  };
};
